import { Link, Stack } from '@mui/material'
import { breakpoints } from '../styles/universal'
import { Typography } from '@mui/material'
import { IoOpenOutline } from 'react-icons/io5'

export const governmentSourcesUpdate = {
    backgroundColor: '#FFCC46',
    headline: 'Important updates regarding U.S. government sources.',
    content: (
        <Stack gap={'1rem'} maxWidth={breakpoints.md} margin={'0 auto'}>
            <Typography>
                <strong>Your safety remains our top priority. </strong>Amid
                recent changes to federal emergency safety websites, some U.S.
                government websites and services may not be available.
            </Typography>
            <Typography>
                HazAdapt continues to provide you with essential, evidence-based
                instructions and source links. Our team of hazard resilience
                experts has spent more than six years researching and
                simplifying information from hundreds of credible,
                scientifically sound sources, which we link for your easy
                access. Our goal is to make every hazard guide clear, available
                offline, and focused on the actions most likely to save lives,
                while still giving you the option to explore the official
                sources in more detail. We carefully review expert consensus to
                make sure our guidance reflects the best available practices
                from sources like practitioner and expert inputs, scientific
                journals, case studies, FEMA, the CDC, the Department of Health
                and Human Services, and many other long-trusted information
                leaders in safety.
            </Typography>
            <Typography component="span" fontWeight={'bold'}>
                Rest assured, you have reliable safety information at your
                fingertips, whenever and wherever you need it with HazAdapt.{' '}
                <Link
                    href="https://www.hazadapt.com/news/ensuring-reliable-access-to-safety-information-amid-recent-government-changes"
                    target="_blank"
                    rel="noopener noreferrer"
                    display={'inline-flex'}
                >
                    Learn More{' '}
                    <div>
                        <IoOpenOutline />
                        <div
                            style={{
                                backgroundColor: 'blue',
                                height: '1px',
                                width: '1rem',
                                marginTop: '-.35rem',
                            }}
                        />
                    </div>
                </Link>
            </Typography>
        </Stack>
    ),
}
